var gl10 = require('./1.0/numbers')

module.exports = function lookupConstant (number) {
  return gl10[number]
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/gl-constants/lookup.js
// module id = UD6v
// module chunks = 0